import React, { useState, useEffect } from 'react';
import { X, Save } from 'lucide-react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const IrrfBracketModal = ({ bracket, onSave, onClose }) => {
  const [formData, setFormData] = useState({
    limiteSuperior: '',
    aliquota: '',
    parcelaDeduzir: '',
    ordem: ''
  });
  
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (bracket) {
      setFormData({
        limiteSuperior: bracket?.limiteSuperior?.toString() || '',
        aliquota: bracket?.aliquota?.toString() || '',
        parcelaDeduzir: bracket?.parceladeduzir?.toString() || '',
        ordem: bracket?.ordem?.toString() || ''
      });
    }
  }, [bracket]);

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData?.limiteSuperior || parseFloat(formData?.limiteSuperior) <= 0) {
      newErrors.limiteSuperior = 'Limite superior é obrigatório e deve ser maior que zero';
    }
    
    if (!formData?.aliquota || parseFloat(formData?.aliquota) < 0) {
      newErrors.aliquota = 'Alíquota é obrigatória e não pode ser negativa';
    }
    
    if (formData?.parcelaDeduzir === '' || parseFloat(formData?.parcelaDeduzir) < 0) {
      newErrors.parcelaDeduzir = 'Parcela a deduzir é obrigatória e não pode ser negativa';
    }
    
    if (!formData?.ordem || parseInt(formData?.ordem) <= 0) {
      newErrors.ordem = 'Ordem é obrigatória e deve ser maior que zero';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    
    if (!validateForm()) return;
    
    onSave({
      limiteSuperior: parseFloat(formData?.limiteSuperior),
      aliquota: parseFloat(formData?.aliquota),
      parcelaDeduzir: parseFloat(formData?.parcelaDeduzir),
      ordem: parseInt(formData?.ordem)
    });
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-card border border-border rounded-lg max-w-md w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-card border-b border-border p-4 flex items-center justify-between">
          <h3 className="text-lg font-semibold text-foreground">
            {bracket ? 'Editar Faixa IRRF' : 'Nova Faixa IRRF'}
          </h3>
          <button
            onClick={onClose}
            className="p-1 hover:bg-muted rounded transition-colors"
          >
            <X className="h-5 w-5 text-muted-foreground" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-4 space-y-4">
          <Input
            label="Ordem"
            type="number"
            min="1"
            placeholder="Ex: 1"
            value={formData?.ordem}
            onChange={(e) => setFormData(prev => ({ ...prev, ordem: e?.target?.value }))}
            error={errors?.ordem}
            required
            description="Posição na tabela (1, 2, 3...)"
          />
          
          <Input
            label="Limite Superior (R$)"
            type="number"
            step="0.01"
            min="0"
            placeholder="Ex: 2259.20"
            value={formData?.limiteSuperior}
            onChange={(e) => setFormData(prev => ({ ...prev, limiteSuperior: e?.target?.value }))}
            error={errors?.limiteSuperior}
            required
            description="Valor máximo desta faixa (use 999999999 para 'acima')"
          />
          
          <Input
            label="Alíquota (%)"
            type="number"
            step="0.01"
            min="0"
            max="100"
            placeholder="Ex: 7.5"
            value={formData?.aliquota}
            onChange={(e) => setFormData(prev => ({ ...prev, aliquota: e?.target?.value }))}
            error={errors?.aliquota}
            required
            description="Percentual de imposto desta faixa"
          />
          
          <Input
            label="Parcela a Deduzir (R$)"
            type="number"
            step="0.01"
            min="0"
            placeholder="Ex: 169.44"
            value={formData?.parcelaDeduzir}
            onChange={(e) => setFormData(prev => ({ ...prev, parcelaDeduzir: e?.target?.value }))}
            error={errors?.parcelaDeduzir}
            required
            description="Valor a deduzir no cálculo do IRRF"
          />

          <div className="flex gap-3 pt-4">
            <Button type="submit" className="flex-1">
              <Save className="h-4 w-4 mr-2" />
              Salvar
            </Button>
            <Button type="button" variant="outline" onClick={onClose} className="flex-1">
              Cancelar
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default IrrfBracketModal;